import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import libraryGroupsAtom from '../libraryGroups.atom'
import libraryGroupsApi from '../libraryGroups.api'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'

const useLibraryGroups = () => {
  const { wait, loading } = useHttpLoader()
  const [libraryGroupsState, setLibraryGroupsState] = useRecoilState(libraryGroupsAtom)

  useEffect(() => {
    if (!libraryGroupsState.loaded) {
      wait(libraryGroupsApi.loadGroups(), (resp) => {
        if (resp.status === 'success') {
          setLibraryGroupsState((prev) => ({
            ...prev,
            items: resp.body.items,
            loaded: true,
          }))
        }
      })
    }
  }, [])

  return { libraryGroupsState, loading: loading || !libraryGroupsState.loaded }
}

export default useLibraryGroups
